import {SerializedStateManagerV1} from '@feature-hub/serialized-state-manager';
import {
    inject,
    postConstruct,
    singleton
} from '../../infrastructure/di/annotations';
import {Logger} from '../logger/Logger';

@singleton('MemoryStore')
export class MemoryStore {
    private map: Record<string, any> = {};

    @inject()
    private serializedStateManager!: SerializedStateManagerV1;

    @inject()
    private logger!: Logger;

    @postConstruct()
    public init(): void {
        this.serializedStateManager.register(() => {
            try {
                return JSON.stringify(this.map);
            } catch (e) {
                this.logger.general.error(
                    'failed to serialize data in memory store',
                    e
                );
                return JSON.stringify(undefined);
            }
        });
        var data = this.serializedStateManager.getSerializedState();

        if (data) {
            try {
                this.map = JSON.parse(data);
                if (typeof this.map !== 'object') {
                    this.map = {};
                }
            } catch (e) {
                this.logger.general.error(
                    'failed to deserialize data in memory store',
                    e
                );
                this.map = {};
            }
        }
    }

    public setData(id: string, data: any): void {
        this.map[id] = data;
    }

    public getData(id: string): any {
        return this.map[id];
    }
}
